import React from "react";
import { FormattedMessage } from "react-intl";

export default [
    {
        name: "nameAr",
        label: <FormattedMessage id="branch.arabic-name" />,
        type: "string",
    },
    {
        name: "nameEn",
        label: <FormattedMessage id="branch.english-name" />,
        type: "string",
    },
    {
        name: "organizationId",
        label: <FormattedMessage id="branch.client" />,
        type: "relation",
        collection: "organizations",
        entityName: "rganization",
        fields: ["name"],
    },
    {
        name: "locationId",
        label: <FormattedMessage id="branch.location" />,
        type: "relation",
        collection: "locations",
        entityName: "location",
        fields: ["name"],
    },
    {
        name: "adminUserIds",
        label: <FormattedMessage id="branch.admin-user" />,
        type: "list",
        helpText: <FormattedMessage id="branch-form.help-txt-admin-user" />,
        url: "/admin-users",
        filterValue: "email",
        entityName: "adminUsers",
        include: true,
    },
];
